// Wrap All in one Div JS Start

function wrapElementsTogether() {
  const elementsToWrap = [
    ...document.querySelectorAll(".product-block--tab"),
    document.querySelector(".product_price_wrapper"),
    document.querySelector(".buy_buttons_wrapper")
  ].filter(Boolean); // remove null values

  if (elementsToWrap.length > 0 && !document.querySelector(".product-block--tab_wrapper")) {
    const newWrapper = document.createElement("div");
    newWrapper.classList.add("product-block--tab_wrapper");
    const firstElement = elementsToWrap[0];
    firstElement.parentNode.insertBefore(newWrapper, firstElement);
    elementsToWrap.forEach(el => {
      newWrapper.appendChild(el);
    });
  }
}

document.addEventListener("DOMContentLoaded", wrapElementsTogether);
window.addEventListener("resize", wrapElementsTogether);
window.addEventListener("orientationchange", wrapElementsTogether);

// Wrap All in one Div JS End

